<div class="merge-view-modal-wrapper">
  <app-base-modal dialogTitle="Add Duplicate" (closeEvent)="onCancel()">
    <p class="body-medium">
      Enter the incident ID or URL to start the merge. Information can change for the merged incident.
    </p>
    <br />

    <mat-form-field appearance="outline" floatLabel="always" class="container-full-width">
      <mat-label>Incident ID or URL (required)</mat-label>
      <input matInput [formControl]="incidentControl" />
      @if (incidentControl.hasError('required')) {
        <mat-error> Incident ID or URL is <strong>required</strong> </mat-error>
      }
      @if (incidentControl.hasError('invalidIncidentIdOrUrl')) {
        <mat-error>
          Enter a numeric incident ID or a valid raven incident URL (for example:
          https://raven.munichre.com/incidents/123).
        </mat-error>
      }
      @if (incidentControl.hasError('backendError')) {
        <mat-error>{{ incidentControl.getError('backendError') }}</mat-error>
      }
    </mat-form-field>

    <div class="warning-container">
      <svg id="warning-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3358_190054)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 0H0V14H14V0ZM7.74994 3H6.24994L6.49994 8.5H7.49994L7.74994 3ZM7.74994 9.5H6.24994V11H7.74994V9.5Z"
            fill="#0f1e32"
          />
        </g>
        <defs>
          <clipPath id="clip0_3358_190054">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Processing rules will be reapplied, and manual edits may be lost. Consider saving manual edits before continuing.
    </div>

    <!-- This is projected by the ng-content of the app-base-modal -->
    <div panel-footer>
      <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
      <button mat-flat-button class="button-primary" (click)="onAddDuplicateAsync()">Add duplicate</button>
    </div>
  </app-base-modal>
</div>
